import synthesizeContractTemplate from '@/views/person-center/project/contract-comp/synthesize-contract-template/synthesize-contract-template.vue';
import ProjectService from '@/views/person-center/project/project.service.js';
import Service from '@/service/index.js';
import { successMessage, errorMessage } from '@/utils/message.js';
export default {
  components: {
    synthesizeContractTemplate
  },
  data() {
    const installmentSumTermValidator = (rule, value, callback) => {
      if (value === '' || !value) {
        return callback(new Error('请输入分期付款的期数'));
      } else if(value <= 0 || value > 100){
        return callback(new Error('1-100'));
      } else {
        callback();
      }
    };
    const installmentPerYearValidator =  (rule, value, callback) => {
      if (value === '' || !value) {
        return callback(new Error('请输入每期多少年'));
      } else if(value <= 0 || value > 10){
        return callback(new Error('1-10'));
      } else {
        callback();
      }
    };
    const installmentPerYearPriceAddPercentValidator = (rule, value, callback) => {
      if (value === '' || value === null) {
        return callback(new Error('请输入每期承包费递增百分比'));
      } else if(value < 0 || value > 100){
        return callback(new Error('0-100'));
      } else {
        callback();
      }
    };
    const contractEffectivePeriodValidator = (rule, value, callback) => {
      if (value === '' || !value) {
        return callback(new Error('请输入'));
      } else if(value <= 0 || value > 100){
        return callback(new Error('1-100'));
      } else {
        callback();
      }
    };
    const afterYearsPayNextPriceValidator =  (rule, value, callback) => {
      if (value === '' || !value) {
        return callback(new Error('请输入'));
      } else if(value <= 0 || value > 10){
        return callback(new Error('1-10'));
      } else if(!this.ruleForm.afterDatePayNextPrice) {
        return callback(new Error('请选择日期'));
      } else {
        callback();
      }
    };
    return {
      // 设置只能选择当前日期及之后的日期
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; // 如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      checked: true,
      checked1: true,
      ruleForm: {
        disposalAncillaryFacilities: [], // 标的涉及的类型数组
        projectDeposit: '', // 项目定金
        contractDeposit: '', // 合同定金
        paymentContractDepositAgreedDay: '', // 支付合同定金约定
        refundContractDepositAgreedDay: '', // 返还合同定金约定
        breachMoney: '',  // 违约金
        projectType: '',
        bidAllowanceAgreement: '', // 标的各种补贴约定
        otherAgreement: '', // 其他约定
        userId: '', // 受让人id
        projectId: '',
        lastDeliverDate: '', // 最晚交付日期
        resolveDisputesWays: '', // 解决争议途径
        lastPayDate: '', // 剩余交付日期
        payType: 1,
        installmentSumTerm: '',
        installmentPerYear: '',
        installmentPerYearPriceAddPercent: '',
        installmentPriceOfFirst: '',
        remainingPriceOfFirstInstallment: '',
        contractEffectivePeriod: '',
        afterYearsPayNextPrice: '',
        afterDatePayNextPrice: '',
        inKindOrOtherMethod: '',
        otherMethod: '',
        sumCurrentPrice: '', // 合同价款合计
        remainMoney: '' // 剩余价款
      },
      projectDepositList: [
        {code: 1, 'value': '需要定金'},
        {code: 2, 'value': '不需要定金'}
      ],
      rules: {
        projectDeposit: [
          { required: true, message: '请选择是否需要定金', trigger: 'change' }
        ],
        contractDeposit: [
          { required: true, message: '请输入合同定金', trigger: 'blur' }
        ],
        paymentContractDepositAgreedDay: [
          { required: true, message: '支付合同定金约定', trigger: 'blur' }
        ],
        refundContractDepositAgreedDay: [
          { required: true, message: '请输入返还合同定金约定日', trigger: 'blur' }
        ],
        lastDeliverDate: [
          { required: true, message: '请选择最晚交付日期', trigger: 'blur' }
        ],
        lastPayDate: [
          { required: true, message: '请选择剩余交付日期', trigger: 'blur' }
        ],
        breachMoney: [
          { required: true, message: '请输入违约金', trigger: 'blur' }
        ],
        installmentSumTerm: [
          { required: true, validator: installmentSumTermValidator, trigger: 'blur' }
        ],
        installmentPerYear: [
          { required: true, validator: installmentPerYearValidator, trigger: 'blur' }
        ],
        installmentPerYearPriceAddPercent: [
          { required: true, validator: installmentPerYearPriceAddPercentValidator, trigger: 'blur' }
        ],
        afterYearsPayNextPrice: [
          { required: true,  validator: afterYearsPayNextPriceValidator, trigger: 'change' }
        ],
        contractEffectivePeriod: [
          { required: true, validator: contractEffectivePeriodValidator, trigger: 'blur' }
        ],
        remainingPriceOfFirstInstallment: [
          { required: true, message: '请输入第一期价款剩余金额', trigger: 'blur' }
        ],
        inKindOrOtherMethod: [
          { required: true, message: '请输入以实物或者实物折资方式', trigger: 'blur' }
        ],
        resolveDisputesWays: [
          { required: true, message: '请选择解决争议途径', trigger: 'change' }
        ],
        bidAllowanceAgreement: [
          { required: true, message: '请输入标的各种补贴约定', trigger: 'blur' }
        ]
      },
      dialogFormVisible: false,
      createContractInfo: {
        projectAssets: {}
      },
      projectSubType: '', // 子类
      disputeWay: null, // 争议解决途径
      previewContract: null, // 预览合同的信息
      massifType: null, // 地块类型
      payTypeArr: null,
      bidGeneralSituationArr: null,
      labelList: ['', '地上附着物处置方式', '地上附着物处置方式', '林地上的附属设施、其他资产情况处置方式', '水面上的附属设施、其他资产情况处置方式', '请输入建筑物的附属设施、其他资产情况处置方式', '请输入农机设备的附属设施、其他资产情况处置方式'] // 综合类标题信息
    };
  },
  created() {
    // console.log(this.type, '瑕疵声明及重大事项提示');
    let fromDate = this.$route.query;
    this.ruleForm.userId = fromDate.userId;
    this.ruleForm.projectId = fromDate.id;
    this.ruleForm.projectType = fromDate.projectType;
    this.projectSubType = fromDate.projectSubType + '';
    this.getDictList();
  },
  watch: {
    'ruleForm.installmentPriceOfFirst'(newName, oldName) {
      if(newName !== oldName) {
        this.ruleForm.remainingPriceOfFirstInstallment = this.ruleForm.installmentPriceOfFirst - (this.createContractInfo.marginSubServiceFee);
      }
    },
    'ruleForm.projectDeposit'(value, oldValue) {
      console.log(oldValue, 'value');
      if(Number(value) === 2 || Number(oldValue) === 2) {
        this.ruleForm = {
          ...this.ruleForm,
          contractDeposit: '',
          paymentContractDepositAgreedDay: '',
          refundContractDepositAgreedDay: ''
        };
      }
    }
  },
  mounted() {
    this.getContractData();
  },
  methods: {
    installmentPriceOfFirstValidator(rule, value, callback) {
      if (value === '') {
        return callback(new Error('请输入第一期价款金额'));
      } else if(value < this.createContractInfo.marginSubServiceFee){
        return callback(new Error('不能小于竞价保证金-服务费'));
      } else {
        callback();
      }
    },
    payDateValidator(rule, value, callback) {
      if (value === '') {
        return callback(new Error('请选择最晚支付日期'));
      } else {
        callback();
      }
    },
    // 验证分期金额是否等于总金额
    validateSumPrice() {
      // 林木并且是分期支付
      if (Number(this.ruleForm.projectSubType) === 3 && Number(this.ruleForm.payType) === 2) {
        let sumNum = Number(this.ruleForm.installmentPriceOfFirst);
        this.ruleForm.installmentPriceOfFirstExList.map(item => {
          sumNum += Number(item.amount);
        });
        // 分期总金额 等于成交总金额
        if(sumNum === Number(this.ruleForm.sumCurrentPrice)) {
          return false;
        }
        return true;
      } else {
        return false;
      }
    },
    change(){
      this.$forceUpdate();
    },
    // 获取用户类型 字典查询
    getDictList () {
      const obj = {
        BID_GENERAL_SITUATION: 'bidGeneralSituationArr',
        DISPUTE_RESOLUTION_WAY: 'disputeWay',
        MASSIF_TYPE: 'massifType',
        PAY_TYPE: 'payTypeArr'
      };
      Object.keys(obj).forEach((key) => {
        Service.getSelectList(key).then(res => {
          if (res && res.code === '0') {
            this[obj[key]] = res.data;
          }
        });
      });
    },
    // 数据回显
    getContractData() {
      ProjectService.toCreateContract(this.ruleForm.projectId, this.ruleForm.userId, this.ruleForm.projectType).then(res => {
        if (res && res.code === '0') {
          this.createContractInfo =  res.data;
          for (let key in this.createContractInfo) {
            if (this.ruleForm.hasOwnProperty(key)) {
              this.ruleForm[key] = this.createContractInfo[key];
              // 第一期价款金额如果小于0 则等于0
              if(res.data.installmentPriceOfFirst < 0) {
                this.createContractInfo.installmentPriceOfFirst = 0;
              }
              // 其他途径复选
              if(key === 'resolveDisputesWays' && res.data.resolveDisputesWays) {
                this.ruleForm.resolveDisputesWays = String(this.ruleForm.resolveDisputesWays);
                this.checked1 = true;
              }
              if (key === 'annualTurnoverPrice') {
                if(this.createContractInfo.sumCurrentPrice > 0 && this.createContractInfo.sumCurrentArea > 0 && Number(this.createContractInfo.deliveryPeriod)>0 ) {
                  this.ruleForm.annualTurnoverPrice = (this.createContractInfo.sumCurrentPrice/this.createContractInfo.sumCurrentArea/this.createContractInfo.deliveryPeriod).toFixed(2);
                } else {
                  this.ruleForm.annualTurnoverPrice = 0;
                }
              }
              if(key === 'resolveDisputesWays') {
                if(this.ruleForm.resolveDisputesWays) {
                  this.ruleForm.resolveDisputesWays = this.ruleForm.resolveDisputesWays && this.ruleForm.resolveDisputesWays.toString();
                } else {
                  this.ruleForm.resolveDisputesWays = '1';
                }
              }
              if(key === 'remainingPriceOfFirstInstallment') {
                if(!res.data.remainingPriceOfFirstInstallment) {
                  this.ruleForm.remainingPriceOfFirstInstallment = this.createContractInfo.installmentPriceOfFirst - this.createContractInfo.marginSubServiceFee;
                }
              }
              if(key === 'disposalAncillaryFacilities') {
                if(!res.data.disposalAncillaryFacilities) {
                  this.ruleForm.disposalAncillaryFacilities = [];
                } else {
                  this.ruleForm.disposalAncillaryFacilities = JSON.parse(this.createContractInfo.disposalAncillaryFacilities);
                }
              }
            }
          }
          if( res.data.projectAssets && res.data.projectAssets.length ) {
            this.ruleForm['projectAssets'] = this.createContractInfo.projectAssets;
          }
        }
      });
    },
    previousStep () {
      this.$router.back();
    },
    // 预览合同
    previewBtn() {
      this.$refs['signUpForm'].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = true;
          this.submit(false);
        } else {
          return false;
        }
      });
    },
    // 立即提交
    test() {
      console.log('1', this.$refs['signUpForm'], this.ruleForm);
      this.$refs['signUpForm'].validate((valid) => {
        if (valid) {
          this.$confirm('是否继续提交合同信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submit(true);
          }).catch(() => {
          });
        } else {
          return false;
        }
      });
    },
    // 确认提交按钮
    submit(isSave) {
      // if(!isSave) {
      //   this.ruleForm.projectAssets = this.ruleForm.projectAssets.map(item => ({
      //     ...item,
      //     assetsInfo: JSON.stringify(item.assetsInfo)
      //   }));
      // };
      // 保存接口传参
      ProjectService.createContract({
        isSave: isSave,
        ...this.ruleForm,
        disposalAncillaryFacilities: JSON.stringify(this.ruleForm.disposalAncillaryFacilities)
      }).then(res => {
        if(isSave) {
          if (res && res.code === '0') {
            successMessage('创建成功');
            this.$router.push('/person-center/project/roll-out-project/list');
          } else if (res && res.reason) {
            errorMessage(res && res.reason);
          } else {
            errorMessage('创建失败');
          }
        } else {
          ProjectService.displayWoodsContract(
            this.ruleForm.projectId,
            this.ruleForm.projectType,
            this.ruleForm.userId,
            '1'
          ).then(res => {
            if (res && res.code === '0') {
              this.previewContract = res.data;
              // this.getContractData();
            }
          });
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('创建失败');
        }
      });
    }
  }
};
